import React, { useState, memo } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Il materiale è digitale o fisico?',
    a: 'Completamente digitale. Scaricalo subito su computer, tablet o smartphone, oppure stampalo quando vuoi.'
  }, {
    q: 'Per quanto tempo avrò accesso?',
    a: 'Per sempre. I materiali sono tuoi a vita, inclusi tutti gli aggiornamenti futuri senza costi aggiuntivi.'
  }, {
    q: 'I pagamenti sono sicuri?',
    a: 'Sì. Processati tramite Hotmart (35M+ utenti) con crittografia SSL a 256 bit. I tuoi dati non vengono mai memorizzati.'
  }, {
    q: 'Come funziona la garanzia?',
    a: 'Hai 30 giorni per provare. Se non sei soddisfatto, invia una email e ricevi il rimborso completo al 100%, senza domande.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 px-4 bg-navy-800" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <h2 className="text-2xl font-bold text-white text-center mb-8" data-id="element-22">
          Domande Frequenti
        </h2>
        <div className="space-y-3" data-id="element-23">
          {faqs.map((faq, index) => <div key={index} className={`bg-navy-900 border rounded-xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-gold-500/50' : 'border-navy-700'}`} data-id="element-24">
              <button className="w-full px-5 py-4 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-25">
                <span className="font-semibold text-white pr-4 text-sm" data-id="element-26">
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 text-gold-400 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-27" />
              </button>
              <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-28">
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-29">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}